import script from "./Slide.vue?vue&type=script&setup=true&lang=js"
export * from "./Slide.vue?vue&type=script&setup=true&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=d9d6eb04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9d6eb04"]])

export default __exports__